import { render, staticRenderFns } from "./ContactRecap.vue?vue&type=template&id=0dac7fb6"
import script from "./ContactRecap.vue?vue&type=script&lang=ts"
export * from "./ContactRecap.vue?vue&type=script&lang=ts"
import style0 from "./ContactRecap.vue?vue&type=style&index=0&id=0dac7fb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports